// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OOZI-","flex_header_container":"Header_flex_header_container__LfoJw","logo_container":"Header_logo_container__t7zhM","logo":"Header_logo__hyzsn"};